import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, formatApiError } from "@/lib/api";

export const AssignEmployeeSelect = ({ contract, onAssigned }) => {
  const [employees, setEmployees] = useState([]);
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/employees", { params: { stato: "tutti" } }).then((r) => setEmployees(r.data)).catch(() => {});
  }, []);

  const assign = async () => {
    if (!value) return;
    setSaving(true);
    try {
      await api.post(`/contracts/${contract.id}/assign`, { employee_id: value });
      toast.success("Documento abbinato al dipendente");
      onAssigned();
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <div className="flex items-center gap-1">
      <Select value={value} onValueChange={setValue}>
        <SelectTrigger className="h-8 w-56 text-xs" data-testid={`assign-select-${contract.id}`}><SelectValue placeholder="Abbina a un dipendente…" /></SelectTrigger>
        <SelectContent className="max-h-72">
          {employees.map((e) => (
            <SelectItem key={e.id} value={e.id} data-testid={`assign-option-${e.id}`}>{e.cognome} {e.nome}{e.attivo ? "" : " (cessato)"}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button size="sm" className="h-8" disabled={!value || saving} onClick={assign} data-testid={`assign-confirm-${contract.id}`}>
        {saving ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Check className="h-3.5 w-3.5" />}
      </Button>
    </div>
  );
};
